var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('description'),_c('links')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }